// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ds","header":"dt","title":"du","subHeader":"dv"};